<template>
    <div class="intro_main">

    </div>
</template>

<script>
import introJS from 'intro.js'
import 'intro.js/introjs.css'
import { http } from "@/utils/http.js";

export default {
    name: 'intro1',
    data() {
        return {
            current_status:0,
            introOption: {
                // 这里是更换成中文（默认英文）
                prevLabel: '上一步',
                nextLabel: '下一步',
                skipLabel: '跳过',
                doneLabel: '完成',
                /* 引导说明框相对高亮说明区域的位置 */
                tooltipPosition: 'bottom',
                /* 引导说明文本框的样式 */
                tooltipClass: 'intro-tooltip',
                /* 说明高亮区域的样式 */
                highlightClass: 'intro-highlight',
                /* 引导说明框相对高亮说明区域的位置 */
                tooltipPosition: 'bottom',
                /* 是否使用键盘Esc退出 */
                exitOnEsc: true,
                /* 是否允许点击空白处退出 */
                exitOnOverlayClick: false,
                /* 提示边框的padding */
                helperElementPadding: 2,
                /* 是否显示说明的数据步骤 */
                showStepNumbers: false,
                /* 是否允许键盘来操作 */
                keyboardNavigation: true,
                /* 是否按键来操作 */
                showButtons: true,
                /* 是否使用点显示进度 */
                showBullets: false,
                /* 是否显示进度条 */
                showProgress: false,
                /* 是否滑动到高亮的区域 */
                scrollToElement: true,
                /* 遮罩层的透明度 */
                overlayOpacity: 0.5,
                /* 当位置选择自动的时候，位置排列的优先级 */
                positionPrecedence: ['bottom', 'top', 'right', 'left'],
                /* 是否禁止与元素的相互关联 */
                disableInteraction: false,
                /* 是否在第一步隐藏上一步 */
                // hidePrev: true,
                /* 是否在最后一步隐藏下一步 */
                // hideNext: true,
                /* steps步骤，可以写个工具类保存起来 */
                steps: [],
            }, // 参数对象
        }
    },
    mounted() {

    },
    methods: {
        open() {
            // 挂载完以后再调用
            this.initGuide()
        },
        accomplish() {

            var that = this
            var obj = {
                guidance_type_id: 'tid_2bb701c28c',
                status:that.current_status
            }
            http("post", process.env.VUE_APP_HOST + "/my_project/guidance_accomplish", obj, true).then(
                (res) => {
                    if (res.code == 0) {
                        that.$Message.success({
                            content: res.msg,
                            duration: 3,
                        });

                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }

                }
            ).catch((res) => {


                console.log(res, '请求出错')
            })

        },


        initGuide() {
            var that = this

            // 绑定标签元素的选择器数组
            this.introOption.steps = [
                {
                    title: '新手引导 1/3',
                    element: '#table_project_name1',
                    intro: '<div>1、点击项目名称，可查看项目详情，导出项目数据。 <br> 2、查看项目基本信息与合同、保险参保数据。</div>',
                },
                {
                    title: '新手引导 2/3',
                    element: '.table_a_box',
                    intro: '<div>面试流程在这里，按流程从左到右。</div>',
                },
                {
                    title: '新手引导 3/3',
                    element: '.hmc_span',
                    intro: '<div>花名册在这里，分【在职花名册】与【离职花名册】，参保与签合同在这里。</div>',
                },

            ]
            introJS()
                .setOptions(this.introOption)
                // 点击结束按钮后执行的事件
                .oncomplete(() => {
                    console.log('点击结束按钮后执行的事件')
                    that.current_status = 1
                    that.accomplish()
                    return

                })
                // 点击跳过按钮后执行的事件
                .onexit(() => {
                    console.log('点击跳过按钮后执行的事件')
                    return
                 

                })
                // 确认完毕之后执行的事件
                .onbeforeexit(() => {
                    console.log('确认完毕之后执行的事件')
                    
                    if(that.current_status==0){
                        that.$Message.warning('未完成学习，我下次还弹出来哟~')
                    }


                   
                })
                .start()
        },
    }
}

</script>

<style  >

.introjs-skipbutton{
    font-size: 13px;
}
</style>